module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "margen row"
  }, [_c('div', {
    staticClass: "login_wrapper",
    style: ({
      backgroundImage: ("url(" + _vm.background + ")")
    })
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.VerLogin),
      expression: "VerLogin"
    }],
    staticClass: "container"
  }, [(_vm.isLoading) ? _c('div', [_c('square')], 1) : _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.verify),
      expression: "verify"
    }]
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "-125px"
    }
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [_c('div', {
    staticClass: "card-flat"
  }, [_c('div', {
    staticClass: "container-card"
  }, [_vm._m(0), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.txtEmail),
      expression: "txtEmail"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Correo electrónico"
    },
    domProps: {
      "value": (_vm.txtEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.txtEmail = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("Escriba el código de verificación que le hemos enviado a su correo eletrónico")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.txtCodigo),
      expression: "txtCodigo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Código de verificación"
    },
    domProps: {
      "value": (_vm.txtCodigo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.txtCodigo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.ValidarCodigo
    }
  }, [_vm._v("Ingresar Código")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "max-width": "750px",
      "margin": "0 auto"
    }
  }, [(_vm.OpcionTipo == 'Postulante') ? _c('div', {
    staticClass: "alert alert-info"
  }, [_vm._m(1), _vm._v(" "), _c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Postulación de Ofertas Laborales               \r\n                    "), _c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Subir CV \r\n                    "), _c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Subir video presentación \r\n                     "), _c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Acceso a entrevistas online\r\n                ")]) : _c('div', {
    staticClass: "alert alert-info"
  }, [_vm._m(2), _vm._v(" "), _c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Publicación de Ofertas Laborales               \r\n                    "), _c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Acceso a CV \r\n                     "), _c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Entrevista online\r\n                ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.login),
      expression: "login"
    }],
    staticClass: "row login-box-12"
  }, [_c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "border-right-style": "solid",
      "border-right-width": "1px",
      "border-right-color": "#ccc"
    }
  }, [_c('div', {
    staticClass: "login-inner-form"
  }, [_c('div', {
    staticClass: "details"
  }, [(_vm.OpcionTipo == 'Postulante') ? _c('div', [_vm._m(3)]) : _c('div', [_vm._m(4)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "min-height": "200px"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [(_vm.OpcionTipo == 'Postulante') ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.TxtEmailIngreso),
      expression: "TxtEmailIngreso"
    }],
    ref: "refEmailPersona",
    staticClass: "input-text",
    attrs: {
      "type": "email",
      "placeholder": "Correo electrónico"
    },
    domProps: {
      "value": (_vm.TxtEmailIngreso)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.onEnterEmailPersonaClick($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.TxtEmailIngreso = $event.target.value
      }
    }
  })]) : _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.TxtEmailIngresoEmpleador),
      expression: "TxtEmailIngresoEmpleador"
    }],
    ref: "refEmail",
    staticClass: "input-text",
    attrs: {
      "type": "email",
      "placeholder": "Correo electrónico"
    },
    domProps: {
      "value": (_vm.TxtEmailIngresoEmpleador)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.onEnterEmailClick($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.TxtEmailIngresoEmpleador = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.OpcionTipo == 'Postulante') ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.TxtClaveIngreso),
      expression: "TxtClaveIngreso"
    }],
    ref: "refPasswordPersona",
    staticClass: "input-text",
    attrs: {
      "type": "password",
      "placeholder": "Contraseña"
    },
    domProps: {
      "value": (_vm.TxtClaveIngreso)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.onEnterPassPersonaClick($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.TxtClaveIngreso = $event.target.value
      }
    }
  })]) : _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.TxtClaveIngresoEmpleador),
      expression: "TxtClaveIngresoEmpleador"
    }],
    ref: "refPassword",
    staticClass: "input-text",
    attrs: {
      "type": "password",
      "placeholder": "Contraseña"
    },
    domProps: {
      "value": (_vm.TxtClaveIngresoEmpleador)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.onEnterPassClick($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.TxtClaveIngresoEmpleador = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox clearfix"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.olvidoContrasena()
      }
    }
  }, [_vm._v("¿ Olvidó su contraseña ?")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12 margin_bottom"
  }, [_c('button', {
    staticClass: "btn btn-block btn-lg btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.Login
    }
  }, [_c('i', {
    staticClass: "fa fa-user margin-left-25",
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" ENTRAR")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "login-inner-form"
  }, [_c('div', {
    staticClass: "details"
  }, [(_vm.OpcionTipo == 'Postulante') ? _c('div', [_vm._m(5)]) : _c('div', [_vm._m(6)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "min-height": "200px"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [(_vm.OpcionTipo == 'Postulante') ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.TxtEmailRegistro),
      expression: "TxtEmailRegistro"
    }],
    staticClass: "input-text",
    attrs: {
      "type": "email",
      "placeholder": "Correo electrónico"
    },
    domProps: {
      "value": (_vm.TxtEmailRegistro)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.TxtEmailRegistro = $event.target.value
      }
    }
  })]) : _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.TxtEmailRegistroEmpleador),
      expression: "TxtEmailRegistroEmpleador"
    }],
    staticClass: "input-text",
    attrs: {
      "type": "email",
      "placeholder": "Correo electrónico"
    },
    domProps: {
      "value": (_vm.TxtEmailRegistroEmpleador)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.TxtEmailRegistroEmpleador = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.OpcionTipo == 'Postulante') ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.TxtClaveRegistro),
      expression: "TxtClaveRegistro"
    }],
    staticClass: "input-text",
    attrs: {
      "type": "password",
      "placeholder": "Contraseña"
    },
    domProps: {
      "value": (_vm.TxtClaveRegistro)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.TxtClaveRegistro = $event.target.value
      }
    }
  })]) : _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.TxtClaveRegistroEmpleador),
      expression: "TxtClaveRegistroEmpleador"
    }],
    staticClass: "input-text",
    attrs: {
      "type": "password",
      "placeholder": "Contraseña"
    },
    domProps: {
      "value": (_vm.TxtClaveRegistroEmpleador)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.TxtClaveRegistroEmpleador = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.OpcionTipo == 'Postulante') ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.TxtNombreRegistro),
      expression: "TxtNombreRegistro"
    }],
    staticClass: "input-text",
    attrs: {
      "type": "text",
      "placeholder": "Nombre"
    },
    domProps: {
      "value": (_vm.TxtNombreRegistro)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.TxtNombreRegistro = $event.target.value
      }
    }
  })]) : _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.TxtNombreRegistroEmpleador),
      expression: "TxtNombreRegistroEmpleador"
    }],
    staticClass: "input-text",
    attrs: {
      "type": "text",
      "placeholder": "Nombre o Nombre fantasía"
    },
    domProps: {
      "value": (_vm.TxtNombreRegistroEmpleador)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.TxtNombreRegistroEmpleador = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.OpcionTipo == 'Postulante') ? _c('div', [_c('button', {
    staticClass: "btn btn-block btn-lg btn-secondary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.CrearCuenta
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil margin-left",
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" CREAR CUENTA")])]) : _c('div', [_c('button', {
    staticClass: "btn btn-block btn-lg btn-secondary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.CrearCuentaEmpleador
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil margin-left",
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" CREAR CUENTA")])])])])])]), _vm._v(" "), (_vm.OpcionTipo == 'Postulante') ? _c('span', {
    staticClass: "FormDivider__LineThrough-sc-1mk5332-0 dHVBa-D"
  }, [_vm._v("o inicia con")]) : _vm._e(), _vm._v(" "), (_vm.OpcionTipo == 'Postulante') ? _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin": "10px"
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('a', {
    staticClass: "btn btn-block btn-social btn-google",
    on: {
      "click": _vm.AccesoGoogle
    }
  }, [_c('span', {
    staticClass: "fa fa-google"
  }), _vm._v(" "), _c('span', [_vm._v("Acceso por Google")])])]), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8)]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_c('i', {
    staticClass: "fa fa-user",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Verificación de cuenta de acceso")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('span', [_c('img', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "src": "/static/img/che.png"
    }
  })]), _vm._v(" "), _c('span', [_c('strong', {
    staticStyle: {
      "font-size": "20px",
      "margin-left": "10px",
      "vertical-align": "bottom"
    }
  }, [_vm._v("ACCESO POSTULANTE")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('span', [_c('img', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "src": "/static/img/che.png"
    }
  })]), _vm._v(" "), _c('span', [_c('strong', {
    staticStyle: {
      "font-size": "20px",
      "margin-left": "10px",
      "vertical-align": "bottom"
    }
  }, [_vm._v("ACCESO EMPLEADOR")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_c('span', [_vm._v("Ingreso postulante")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_c('span', [_vm._v("Ingreso empleador")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_c('span', [_vm._v("Crear cuenta postulante")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_c('span', [_vm._v("Crear cuenta empleador")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4"
  }, [_c('a', {
    staticClass: "btn btn-block btn-social btn-facebook"
  }, [_c('span', {
    staticClass: "fa fa-facebook"
  }), _vm._v(" "), _c('span', [_vm._v("Acceso por Facebook")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4"
  }, [_c('a', {
    staticClass: "btn btn-block btn-social btn-linkedin"
  }, [_c('span', {
    staticClass: "fa fa-linkedin"
  }), _vm._v(" "), _c('span', [_vm._v("Acceso por Linkedin")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e5d6b8c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/LoginView.vue
// module id = 646
// module chunks = 1